import * as React from 'react';
import { useDarkMode } from './useDarkMode';

const ThemeContext = React.createContext({
    theme: 'light',
    toggleTheme: () => {},
});

export function ThemeProvider({ children }) {
    const [theme, toggleTheme, componentMounted] = useDarkMode();

    const value = React.useMemo(
        () => ({ theme, toggleTheme, componentMounted }),
        [theme, toggleTheme, componentMounted]
    );

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = React.useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}